module.exports = __webpack_public_path__ + "static/img/Updates version 2.6.0.155275a.png";